// The logo and the contact photo of a member, as Fintrack sets them from the CRM.
// Same limits the API enforces and the member's own Company Settings screen uses,
// checked here first so a wrong file is refused before anything is uploaded.
export const MEMBER_IMAGE_MAX_BYTES = 2 * 1024 * 1024;
export const MEMBER_IMAGE_ACCEPT = "image/png,image/jpeg";

export function checkMemberImage(file: File | null | undefined, what: string): string {
    if (!file) return "";
    if (!["image/png", "image/jpeg"].includes(file.type)) return `The ${what} must be a PNG or JPG image.`;
    if (file.size > MEMBER_IMAGE_MAX_BYTES) return `The ${what} must be 2MB or smaller.`;
    return "";
}
